export function collectErrorPaths(errors: unknown, prefix = ""): string[] {
  if (!errors || typeof errors !== "object") return [];

  const paths: string[] = [];

  Object.entries(errors as Record<string, unknown>).forEach(([key, value]) => {
    if (!value || typeof value !== "object") return;

    const path = prefix ? `${prefix}.${key}` : key;

    if ("message" in value && value.message) {
      paths.push(path);
      return;
    }

    paths.push(...collectErrorPaths(value, path));
  });

  return paths;
}
